import { Box, HStack, Image, Kbd, Spacer, Text } from '@chakra-ui/react';
import { useAuth } from 'react-oidc-context';

import { AddCompanyDialog } from './AddCompanyDialog';
import Logo from '/assets/images/pilotrse-logo.png';

export function WelcomeHeader() {
  const auth = useAuth();

  return (
    <HStack alignItems={'flex-start'} py={8} mb={8}>
      <Box alignSelf="center">
        <Image src={Logo} alt="Company Logo" maxW="200px" objectFit="cover" />
      </Box>
      <Box mx={4}>
        <Text fontSize="2xl">Hi, {auth.user?.profile?.name} 👋🏼</Text>
        <Text>Bienvenue, c'est un plaisir de vous revoir !</Text>
        <Text pt={4} maxW="3xl">
          Sélectionnez l'entreprise de votre choix ci-dessous et prenez le contrôle de votre stratégie RSE ! 🌱📊 Gérez
          vos plans, pilotez vos actions, suivez vos indicateurs et optimisez vos collectes en toute simplicité. 🚀
        </Text>
        <Text>
          🔎 Pour trouver une entreprise plus rapidement, utilisez le raccourci clavier <Kbd>Ctrl</Kbd> + <Kbd>F</Kbd>{' '}
          et gagnez du temps !
        </Text>
      </Box>
      <Spacer />
      <Box>
        <AddCompanyDialog />
      </Box>
    </HStack>
  );
}
